import React from "react";
import PageShell from "../components/layout/PageShell";
import TalentHero from "../features/talent/TalentHero";
import HiringPrograms from "../features/talent/HiringPrograms";
import DashboardsSection from "../components/shared/DashboardsSection";
import ContactSection from "../components/shared/ContactSection";
import SearchAssistant from "../components/shared/SearchAssistant";

export default function TalentPage() {
  return (
    <PageShell>
      <TalentHero />
      <HiringPrograms />
      <DashboardsSection />
      <SearchAssistant />
      <ContactSection />
    </PageShell>
  );
}